import { render, staticRenderFns } from "./AgregarEdificio.vue?vue&type=template&id=5d96dee5&"
import script from "./AgregarEdificio.vue?vue&type=script&lang=js&"
export * from "./AgregarEdificio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports